import React, { useState, useEffect } from "react";
import { getOrgUsers, getOrgInvitations, inviteOrgUser, deleteOrgInvitation } from "../services/organizationService";
import { OrganizationUser } from "../types/organization";
import InviteUserModal from "./InviteUserModal";
import { useLocation, useNavigate } from "react-router-dom";

const Organization: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isOnboarding = location.pathname.includes('onboarding');
  const [activeUsers, setActiveUsers] = useState<OrganizationUser[]>([]);
  const [invitedUsers, setInvitedUsers] = useState<OrganizationUser[]>([]);
  const [isInviteUserModalOpen, setIsInviteUserModalOpen] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    getOrgUsers().then(setActiveUsers);
    getOrgInvitations().then(setInvitedUsers);
  }, []);

  const handleInviteUser = (email: string) => {
    setIsInviteUserModalOpen(false);

    inviteOrgUser(email).then(() => {
      getOrgInvitations().then((invitations) => {
        setInvitedUsers(invitations);
      });
    }).catch((error) => {
      setErrorMessage(error.response.data.error);
      setTimeout(() => setErrorMessage(""), 1500);
    });
  }

  const handleCancelInvite = (invitationId: string) => {
    if (!window.confirm("Cancel this invite?")) return;

    deleteOrgInvitation(invitationId).then(() => {
      setInvitedUsers((current) => current.filter((user) => user.id !== invitationId));
    }).catch((error) => {
      setErrorMessage(error.response?.data?.error || "Failed to cancel invite");
      setTimeout(() => setErrorMessage(""), 1500);
    });
  }


  const allUsers = [
    ...activeUsers.map((user) => ({ ...user, status: "Active" })),
    ...invitedUsers.map((user) => ({ ...user, status: "Pending" }))
  ];

  return (
    <div>
      <div
        style={{
          filter: isInviteUserModalOpen ? "blur(4px)" : "none",
          pointerEvents: isInviteUserModalOpen ? "none" : "auto",
        }}
      >
        {!isOnboarding && <h1>Team</h1>}

        {errorMessage &&
          <div style={{
            backgroundColor: "#FFEBEE",
            color: "#D32F2F",
            width: "13.7em",
            padding: "10px",
            marginBottom: "15px",
            borderRadius: "4px",
            border: "1px solid #FFCDD2"
          }}>
            {errorMessage}
          </div>
        }

        <ul className="newsletter-list">
          {allUsers.map((user: OrganizationUser) => (
            <li
              key={user.id}
              className="newsletter-item"
              onClick={() => user.status === "Active" && !isOnboarding && navigate(`/team/${user.id}`)}
              style={{ cursor: user.status === "Active" && !isOnboarding ? "pointer" : "default" }}
            >
              <div className="newsletter-item-content-left">
                <span className="newsletter-title">
                  {user.email}
                </span>
              </div>

              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                paddingRight: "16px",
              }}>
                <span
                  className={user.status === "Active" ? "list-tag-green-active" : "list-tag-gray"}
                  style={{
                    width: "126px",
                    marginRight: "16px"
                  }}
                >
                  {user.status}
                </span>

                {user.status === "Pending" && (
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCancelInvite(user.id);
                    }}
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                      color: "inherit",
                    }}
                  >
                    Cancel
                  </span>
                )}
              </div>
            </li>
          ))}
        </ul>

        <div>
          <button className="primary-button" onClick={() => setIsInviteUserModalOpen(true)}>+ Invite</button>
        </div>
      </div>

      {isInviteUserModalOpen &&
        <InviteUserModal
          onClose={() => setIsInviteUserModalOpen(false)}
          onInviteUser={handleInviteUser}
        />
      }
    </div>
  );
}

export default Organization;
